/* istanbul ignore file */
export enum StepNames {
  DocumentAndClient = "Document and client details",
  PayableDetails = "Payable details",
  Complete = "Complete",
  Error = "Error",
}
